import {RoleService} from "./service/api/role.service";
import {UmUserService} from "./service/api/um-user.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";
import {
    UmRoleObjectComponent
} from "./component/protected-components/object/um-role-object-component/um-role-object.component";

export const UM_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['um.RoleAuthConfig', {route: '/um/roleAuthConfigs'}],
            ['um.RoleAuthModule', {route: '/um/roleAuthModules'}],
            // ['um.RoleAuthModuleQueryStart', {route: '/um/roleAuthModuleQueryStarts'}],
            // ['um.RoleAuthModuleFeature', {route: '/um/roleAuthModuleFeatures'}],
            ['um.UserRole', {route: '/um/userRoles'}],
            ['um.Role', {route: '/um/roles', service: RoleService, objectComponent: [{component: UmRoleObjectComponent}]}],
            ['um.User', {route: '/um/users', service: UmUserService}],
            ['um.UmDocumentConfiguration', {route: '/um/umDocumentConfigurations'}],

            ['um.UserImage', {route: '/um/userImages'}],
            ['um.RoleAuthObjectType', {route: '/um/roleAuthObjectTypes'}],
            ['um.UserNotificationType', {route: '/um/userNotificationTypes'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
